export default "__VITE_PUBLIC_ASSET__46d05110__"